import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Icon } from '@bwoty-web/styleguide';
import './rating.scss';

const Rating = ({ rating, maxRating, linkText, iconPath, className, onClick }) => {
  const classes = classnames('gw-hotel-info-rating', className);

  return (
    <button className={classes} type="button" onClick={() => onClick()}>
      <div className="gw-hotel-info-rating__icon-rating-container">
        <Icon
          className="gw-hotel-info-rating__icon"
          path={iconPath}
          size="s"
          sizeMobile="xs"
          aria-hidden="true"
        />
        {rating}/{maxRating}
      </div>
      <div className="gw-hotel-info-rating__link-text">{linkText}</div>
    </button>
  );
};

Rating.propTypes = {
  className: PropTypes.string,
  rating: PropTypes.number.isRequired,
  maxRating: PropTypes.number.isRequired,
  linkText: PropTypes.string,
  iconPath: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

Rating.defaultProps = {
  className: null,
  linkText: null,
  iconPath: null,
};

export default Rating;
